import { render } from "./PosteVoyage.vue?vue&type=template&id=3d971412&scoped=true&ts=true"
import script from "./PosteVoyage.vue?vue&type=script&lang=ts"
export * from "./PosteVoyage.vue?vue&type=script&lang=ts"

import "./PosteVoyage.vue?vue&type=style&index=0&id=3d971412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d971412"]])

export default __exports__